import { render, staticRenderFns } from "./rewardList.vue?vue&type=template&id=0beb4460&scoped=true&"
import script from "./rewardList.vue?vue&type=script&lang=js&"
export * from "./rewardList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0beb4460",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0beb4460')) {
      api.createRecord('0beb4460', component.options)
    } else {
      api.reload('0beb4460', component.options)
    }
    module.hot.accept("./rewardList.vue?vue&type=template&id=0beb4460&scoped=true&", function () {
      api.rerender('0beb4460', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/divisionManage/rewardController/component/rewardList.vue"
export default component.exports